import { render, staticRenderFns } from "./PembayaranPenelitiKeamanan.vue?vue&type=template&id=6096ab74&"
import script from "./PembayaranPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./PembayaranPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports